import { Component, OnInit } from '@angular/core';
import { News } from '@app/models/news';
import { NewsService } from '@app/services/news.service';
import { map } from 'rxjs/operators';
import { PlatformService } from '@app/services';
@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss']
})
export class NewsListComponent implements OnInit {

  news: News[];
  newsFiltered: News[];

  constructor(
    private newsService: NewsService,
    public platformService: PlatformService,
  ) {
    this.loadNews();
  }

  ngOnInit() {
  }

  getThumbnail(aNews: News) {
    return aNews.content.substr(0, 100);
  }

  filterNews(event) {
    this.newsFiltered = event;
  }

  loadNews() {
    this.newsService.getAllNews('public').subscribe(news => {
      this.news = news;
    });
  }
}
